import React from 'react'
import { IoShareOutline } from "react-icons/io5";
import styled from 'styled-components';

const SharePage = () => {

  const share = () =>{
    if(navigator.share){
      navigator.share({
        text :'Checkout this cool website!',
        url:''
      })
    } else{
      navigator.clipboard.writeText('code we want tocopy')   
    }}
  return (
      <Wrapper>
        <div className='container py-1' >
            <div className='d-flex justify-content-center align-items-center flex-column share-page' style={{backgroundColor:"#fff !important"}}>
                <button 
                  className='rounded-pill d-flex justify-content-center align-items-center gap-2 border border-2' 
                  style={{color:'#000 !important',paddingRight:"6rem",width:'auto',paddingLeft:"6rem",backgroundColor:"#ffff"}}
                  onClick={()=>{share()}}
                  ><IoShareOutline/> Share</button>
                <p className='pt-3 ' style={{color:"#000000ff",fontWeight:"500"}}>Share this page with your friends.</p>
                {/* <span class="rounded-pill border" style={{width:"130px"}}><IoShareOutline/> Share</span> */}
            </div>
        </div>
      </Wrapper>
  )
}

export default SharePage

const Wrapper = styled.section`
  .share-page{
    height:10rem;
  }
  @media(max-width:768px){
    .share-page{
      height:6rem;
    }
  }
`
